// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore.js";
import "./sceneUboDeclaration.js";
import "./meshUboDeclaration.js";
const name = "shadowMapUboDeclaration";
const shader = `layout(std140,column_major) uniform;#include<sceneUboDeclaration>
#include<meshUboDeclaration>
`;
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
/** @internal */
export const shadowMapUboDeclaration = { name, shader };
//# sourceMappingURL=shadowMapUboDeclaration.js.map